<style scoped lang="less">
@import "./style.less";
</style>
<template>
  <!-- button -->
  <div class="button-group">
    <div
      v-for="button of buttonList"
      :key="button.label"
      :class="{
        'button-group__button-active': button.active,
        'button-group__button-disabled': button.disabled
      }"
      class="button-group__button"
      @click="clickButton(button)"
    >
      {{button.label}}
    </div>
  </div>
</template>
<script>
import methods from './methods'
export default {
  name: "buttonGroup",
  mixins:[methods],
}
</script>
